import { render, staticRenderFns } from "./dimension-form-3.vue?vue&type=template&id=db8783c0&scoped=true&"
import script from "./dimension-form-3.vue?vue&type=script&lang=ts&"
export * from "./dimension-form-3.vue?vue&type=script&lang=ts&"
import style0 from "./dimension-form-3.vue?vue&type=style&index=0&id=db8783c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8783c0",
  null
  
)

export default component.exports